// extracted by mini-css-extract-plugin
module.exports = {"logo-sections":"styles_logo-sections__jM4bt","grayscale":"styles_grayscale__OxeI2","logo-img":"styles_logo-img__N2O79"};